// Tela vazia genérica — placeholder reutilizável para rotas ainda não construídas.
import { useTranslation } from "react-i18next";
import "./i18n.js";

export function EmptyScreen({ title }: { title: string }) {
  const { t } = useTranslation();
  return (
    <main className="p-6">
      <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
      <div className="mt-6 flex min-h-[40vh] items-center justify-center rounded-lg border border-dashed border-border text-sm text-muted-foreground">
        {t("emptyScreen.label")}
      </div>
    </main>
  );
}
